import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center px-6 text-center">
      <span className="font-heading text-[160px] md:text-[200px] leading-none text-background-300 italic font-light select-none">
        404
      </span>
      <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-2">
        Página não encontrada
      </h1>
      <p className="mt-3 text-sm text-foreground-500 max-w-sm leading-relaxed">
        A página que você procura pode ter sido removida ou o endereço digitado está incorreto.
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-primary-500 text-white text-sm tracking-[0.06em] uppercase whitespace-nowrap hover:bg-primary-600 transition-colors duration-300 font-label"
      >
        <i className="ri-arrow-left-line"></i>
        Voltar ao início
      </Link>
    </div>
  );
}